import { render } from "./ITable.vue?vue&type=template&id=7b36a478"
import script from "./ITable.vue?vue&type=script&lang=js"
export * from "./ITable.vue?vue&type=script&lang=js"

import exportComponent from "/pro/vue/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__